import {ICreateTeam, IHerd, IJoinTeam, IRemovePlayer} from "modules/reducers/herds";
import {IError} from "modules/types";
import {createAction} from "redux-act";

export const createTeam = createAction<ICreateTeam>('createTeam');
export const createTeamSuccess = createAction<IHerd>('createTeamSuccess');
export const createTeamFailed = createAction<Error>('createTeamFailed');

export const updateTeam = createAction<ICreateTeam>('updateTeam');
export const updateTeamSuccess = createAction<IHerd>('updateTeamSuccess');
export const updateTeamFailed = createAction<Error>('updateTeamSuccess');

export const fetchTeam = createAction('fetchTeam');
export const fetchTeamSuccess = createAction<IHerd>('fetchTeamSuccess');
export const fetchTeamFailed = createAction('fetchTeamFailed');

export const joinToTeam = createAction<IJoinTeam>('joinToTeam');
export const joinToTeamSuccess = createAction<IHerd>('joinToTeamSuccess');
export const joinToTeamFailed = createAction('joinToTeamFailed');

export const leaveFromTeam = createAction('leaveFromTeam');
export const leaveFromTeamSuccess = createAction('leaveFromTeamSuccess');
export const leaveFromTeamFailed = createAction('leaveFromTeamFailed');

export const showModalCaptain = createAction('showModalCaptain');
export const hideModalCaptain = createAction('hideModalCaptain');


export const showModalNewCaptain = createAction('showModalNewCaptain');
export const hideModalNewCaptain = createAction('hideModalNewCaptain');

export const showModalInviteCaptain = createAction('showModalInviteCaptain');
export const hideModalInviteCaptain = createAction('hideModalInviteCaptain');


export const changeCaptain = createAction<number>('changeCaptain');
export const changeCaptainSuccess = createAction<IHerd>('changeCaptainSuccess');
export const changeCaptainFailed = createAction<IError>('changeCaptainFailed');

export const removePlayer = createAction<IRemovePlayer>('removePlayer');
export const removePlayerSuccess = createAction<IHerd>('removePlayerSuccess');
export const removePlayerFailed = createAction<Error>('removePlayerFailed');

export const removeTeam = createAction('removeTeam');
export const removeTeamSuccess = createAction('removeTeamSuccess');
export const removeTeamFailed = createAction<Error>('removeTeamFailed');

export const reviveTeam = createAction('reviveTeam');
export const reviveTeamSuccess = createAction<IHerd>('reviveTeamSuccess');
export const reviveTeamFailed = createAction<Error>('reviveTeamFailed');
